import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

function Ring({ factor, scale, opacity, dashed }) {
  const s = useTransform(scale, (v) => Math.max(0.001, v * factor));
  return (
    <motion.div
      style={{ scale: s, opacity }}
      className={`absolute h-[46vmin] w-[46vmin] rounded-full border ${
        dashed ? "border-dashed border-[#D4AF37]/25" : "border-[#D4AF37]/40"
      }`}
    />
  );
}

export default function PortalTransition({ act, title, sub, testId }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0.05, 0.95], [0.4, 18]);
  const ringOpacity = useTransform(scrollYProgress, [0.05, 0.3, 0.7, 0.9], [0, 1, 1, 0]);
  const dim = useTransform(scrollYProgress, [0, 0.35, 0.65, 1], [0, 0.72, 0.72, 0]);
  const textOpacity = useTransform(scrollYProgress, [0.32, 0.45, 0.58, 0.7], [0, 1, 1, 0]);
  const textY = useTransform(scrollYProgress, [0.32, 0.7], [70, -70]);
  const glow = useTransform(scrollYProgress, [0.3, 0.5, 0.7], [0, 0.5, 0]);

  return (
    <div ref={ref} data-testid={testId} className="relative z-10 h-[240vh]">
      <div className="sticky top-0 flex h-screen items-center justify-center overflow-hidden">
        <motion.div style={{ opacity: dim }} className="absolute inset-0 bg-black" />
        <motion.div
          style={{ opacity: glow }}
          className="absolute h-[60vmin] w-[60vmin] rounded-full bg-[#D4AF37]/20 blur-3xl"
        />
        <Ring factor={1} scale={scale} opacity={ringOpacity} />
        <Ring factor={1.5} scale={scale} opacity={ringOpacity} dashed />
        <Ring factor={2.2} scale={scale} opacity={ringOpacity} />
        <motion.div style={{ opacity: textOpacity, y: textY }} className="relative px-6 text-center">
          <p className="mb-6 text-[11px] tracking-[0.55em] text-[#D4AF37] md:text-sm">{act}</p>
          <p
            aria-hidden="true"
            className="font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl"
          >
            {title}
          </p>
          <p className="mt-6 font-serif-accent text-xl italic text-[#BDBDB6] md:text-2xl">{sub}</p>
        </motion.div>
      </div>
    </div>
  );
}
